import { API_CONFIG } from '@/config/api';
import { httpClient } from '@/utils/httpClient';

export interface CatalogImportPayloadRow {
  rowNumber: number;
  values: Record<string, unknown>;
}

export interface CatalogImportErrorDetail {
  rowNumber: number | null;
  column: string | null;
  message: string;
}

export interface CatalogImportSummary {
  totalRows: number;
  createCount: number;
  updateCount: number;
}

export interface CatalogImportPreviewRow {
  rowNumber: number;
  operation: 'create' | 'update';
  entityId: string;
  entityIdentifier: string;
  displayName: string;
}

export interface CatalogImportResponse {
  success: boolean;
  validateOnly: boolean;
  summary: CatalogImportSummary;
  preview: CatalogImportPreviewRow[];
}

class CatalogImportService {
  private endpoint = `${API_CONFIG.ACTIONS_API_BASE_PATH}/catalog/import`;

  async validateImport(rows: CatalogImportPayloadRow[]): Promise<CatalogImportResponse> {
    return httpClient.post<CatalogImportResponse>(this.endpoint, {
      rows,
      validateOnly: true,
    });
  }

  async applyImport(rows: CatalogImportPayloadRow[]): Promise<CatalogImportResponse> {
    return httpClient.post<CatalogImportResponse>(this.endpoint, {
      rows,
      validateOnly: false,
    });
  }
}

export const catalogImportService = new CatalogImportService();
